export const defaultConfigState = {
  /**
   * Cờ đang xử lý
   */
  loading: false,
  /**
   * dữ liệu thiết lập của người dung
   */
  data: {},
};

export default {
  ...defaultConfigState,
};
